<template>
  <div class="app-main-content">
    <div class="main-content" style="overflow: auto;">
      <div v-show="!isPreview" style="width: fit-content">
        <div style="display: flex">
          <div v-for="block in blocks" :key="block.pagePart.pagePartName" class="section" style="width: 336px;">
            <el-form label-width="140px" label-position="right">
              <el-form-item label=" ">
                <span class="element-column-text" :title="$t('SeaExport.Display')">{{ $t('SeaExport.Display') }}</span>
                <span v-if="!hideRequired" class="element-column-text" :title="$t('SeaExport.Required')">{{ $t('SeaExport.Required') }}</span>
                <span v-if="!hideAlias" class="element-column-text" :title="$t('SystemMaintenance.Alias')" style="width: 80px;">{{ $t('SystemMaintenance.Alias') }}</span>
                <span v-if="!hideSetting" class="element-column-text" :title="$t('Tool.Setting')">{{ $t('Tool.Setting') }}</span>
              </el-form-item>
              <el-form-item v-for="element in (block.serialNumber === 1 ? firstBlockElements : block.uiCustomElementList)" :key="element.pagePartElement.elementName">
                <span slot="label" :class="element.isRequire ? 'blue' : ''">{{ element.sysLabel }}</span>
                <el-checkbox
                  v-model="element.isDisplay"
                  :disabled="readonly || !element.pagePartElement.displayCanCustom || (!!element.hqUICustomElement && element.hqUICustomElement.isRequire) || checkHqSetDisable(element)"
                  class="element-column-content"
                  @change="onDisplayChange(block, element)"
                />
                <el-checkbox
                  v-if="!hideRequired"
                  v-model="element.isRequire"
                  :disabled="readonly || !element.pagePartElement.requireCanCustom || !element.isDisplay || (!!element.hqUICustomElement && element.hqUICustomElement.isRequire) || checkHqSetDisable(element)"
                  class="element-column-content"
                />
                <span v-if="!hideAlias" class="element-column-text" :title="element.customLabel" style="width: 80px;pointer-events: auto;">{{ element.customLabel }}</span>
                <!-- 元素设置 -->
                <template v-if="!hideSetting">
                  <span v-if="readonly" class="element-column-content">
                    <div v-if="(element.languageList && element.languageList.length > 0) || element.multipleRole" class="look-blue" @click="onEditElementLabel(element)" />
                    <div v-else class="look-gray" />
                  </span>
                  <span v-if="!readonly" :class="'element-column-content' + (element.isDisplay ? '' : ' el-icon-edit-disabled')">
                    <i class="el-icon-edit" @click="onEditElementLabel(element)" />
                  </span>
                </template>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-- 预览 -->
      <cargo-ag-grid
        v-if="isPreview"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="[]"
      />
    </div>
    <!-- 元素设置弹窗 -->
    <element-set-dialog :visible.sync="elementSetDialog.visible" :element="elementSetDialog.element" />
  </div>
</template>

<script>
import ElementSetDialog from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/ElementSetDialog'

export default {
  name: 'GridTabScript',
  components: { ElementSetDialog },
  props: {
    branchId: { type: Number, required: true },
    isEdit: { type: Boolean, required: true },
    blocks: { type: Array, required: true },
    addedElements: { type: Array, required: true },
    isPreview: { type: Boolean, required: true },
    previewConfig: { type: Object, default: null },
    hideRequired: { type: Boolean, default: false }, // 是否隐藏必填标记
    hideAlias: { type: Boolean, default: false }, // 是否隐藏别名
    hideSetting: { type: Boolean, default: false } // 是否隐藏设置
  },
  data() {
    return {
      gridOptions: {
        rowSelection: 'multiple',
        context: {
          componentParent: this
        }
      },
      elementSetDialog: {
        visible: false,
        element: {}
      }
    }
  },
  computed: {
    readonly() {
      return !this.isEdit
    },
    firstBlockElements() {
      if (this.blocks.length > 0) {
        if (this.addedElements && this.addedElements.length > 0) {
          const elements = this.blocks[0].uiCustomElementList
          const nameSet = new Set()
          for (const element of elements) {
            nameSet.add(element.pagePartElement.elementName)
          }
          for (const addedElement of this.addedElements) {
            if (!nameSet.has(addedElement.pagePartElement.elementName)) {
              elements.push(addedElement)
            }
          }
          elements.sort((a, b) => a.serialNumber - b.serialNumber)
        }
        return this.blocks[0].uiCustomElementList
      }
      return []
    },
    columnDefs() {
      const result = []
      for (const element of this.firstBlockElements) {
        if (element.isDisplay) {
          result.push({
            headerName: element.customLabel || element.sysLabel,
            field: element.pagePartElement.elementName
          })
        }
      }
      return result
    }
  },
  methods: {
    checkHqSetDisable(element) {
      return element.useHqSet && !!element.hqUICustomElement && !element.hqUICustomElement.isDisplay
    },
    onEditElementLabel(element) {
      this.elementSetDialog.element = element
      this.elementSetDialog.visible = true
    },
    onDisplayChange(block, element) {
      if (element.isDisplay) {
        if (element.pagePartElement.masterIncluded) {
          element.masterIsDisplay = true
        }
        element.slaveIdDisplay = true
        block.hide = false
      } else {
        element.masterIsDisplay = false
        element.slaveIdDisplay = false
        element.isRequire = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./base.scss";
</style>
